import { LabeledHorizontalArrow } from './arrow';

type HorizontalArrowsProps = {
  width: number;
  centerX?: number;
  leftLabel?: string;
  rightLabel?: string;
  /** Height reserved for the arrow row (used to size the containing SVG). */
  height?: number;
};

/**
 * Two outward-pointing arrows with labels, intended to render below a
 * DivergingBarChart to describe what the left and right sides represent.
 */
export const HorizontalArrows = ({
  width,
  centerX: centerXProp,
  leftLabel,
  rightLabel,
  height = 25,
}: HorizontalArrowsProps) => {
  let offsetFromCenter: number;
  let maxWidth: number | undefined;

  const centerX = centerXProp ?? width / 2;

  if (width >= 500) {
    offsetFromCenter = 130;
    maxWidth = undefined;
  } else if (width >= 350 && width <= 400) {
    offsetFromCenter = width * 0.28;
    maxWidth = width * 0.25;
  } else if (width >= 350) {
    offsetFromCenter = 100;
    maxWidth = undefined;
  } else {
    offsetFromCenter = Math.max(55, width * 0.28);
    maxWidth = width * 0.25;
  }

  return (
    <svg width="100%" height={height}>
      {leftLabel && (
        <LabeledHorizontalArrow
          direction="left"
          x={centerX - offsetFromCenter}
          y={0}
          label={leftLabel}
          maxWidth={maxWidth}
        />
      )}
      {rightLabel && (
        <LabeledHorizontalArrow
          direction="right"
          x={centerX + offsetFromCenter}
          y={0}
          label={rightLabel}
          maxWidth={maxWidth}
        />
      )}
    </svg>
  );
};
